import React from 'react'
import { SVGIconProps } from '../types'
const SvgTableRows = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M22 7H2V2h20zm0 2.5H2v5h20zm0 7.5H2v5h20z" />
  </svg>
)
export default SvgTableRows
